// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";

let jsonCodec = Jzon.object3(param => [
  param.forEmailAddress,
  param.identityProviderName,
  param.samlRequestUrl
], param => ({
  TAG: "Ok",
  _0: {
    forEmailAddress: param[0],
    identityProviderName: param[1],
    samlRequestUrl: param[2]
  }
}), Jzon.field("forEmailAddress", Jzon.string), Jzon.optional(Jzon.field("identityProviderName", Jzon.string)), Jzon.optional(Jzon.field("samlRequestUrl", Jzon.string)));

let RequestData = {
  jsonCodec: jsonCodec
};

export {
  RequestData,
}
/* jsonCodec Not a pure module */
